var map = {
	"./(Favicon) Dragon Dream Digital.svg": "8988",
	"./Contact us.svg": "86df",
	"./bg.svg": "e748",
	"./blue_elipse.svg": "b912",
	"./dragondream-icon.svg": "031a",
	"./icon_contact.svg": "31d7",
	"./icon_email.svg": "c3a6",
	"./in_the_works.svg": "e028",
	"./soon.svg": "367f",
	"./svg_web.svg": "d0e9",
	"./svg_web_1.svg": "e464",
	"./svg_web_2.svg": "1747",
	"./svg_world_map.svg": "3d41"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dda1";